export enum CompanyStatusEnum {
  awaiting_contract = 'awaiting_contract',
  awaiting_signature = 'awaiting_signature',
  active = 'active',
  blocked = 'blocked',
  canceled = 'canceled',
  under_analysis = 'under_analysis',
}

export enum CompanyFormattedStatusEnum {
  awaiting_contract = 'Aguardando envio do contrato',
  awaiting_signature = 'Aguardando assinatura',
  active = 'Ativo',
  blocked = 'Bloqueado',
  canceled = 'Cancelado',
  under_analysis = 'Em análise',
}
